import { render, staticRenderFns } from "./CommentsWithRightAvatar.vue?vue&type=template&id=475d96a6"
import script from "./CommentsWithRightAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentsWithRightAvatar.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports